import { LocationInterface } from "../../models/TicketModule/Location";
import client from "../client";

class LocationService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/Locations/get`;

      let formData = {
        page,
        pageSize,
      };

      const { data } = await client.post<LocationInterface[]>(url, formData);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetAllWithCompId(
    page: number,
    pageSize: number,
    companyId: string | undefined
  ) {
    try {
      let url = `/api/Locations/get`;
      let formData = {
        page,
        pageSize,
        companyId: companyId,
      };
      if (!companyId) {
        return [];
      } else {
        const { data } = await client.post<LocationInterface[]>(url, formData);
        return data;
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/Locations/getbyid/${id}`;

      const { data } = await client.get<LocationInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(location: LocationInterface) {
    try {
      let url = `/api/Locations/add`;

      const { data } = await client.post<LocationInterface>(url, location);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, location: LocationInterface) {
    try {
      let url = `/api/Locations/update/${id}`;

      const { data } = await client.post<LocationInterface>(url, location);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/Locations/remove/${id}`;
      await client.post<LocationInterface>(url, { url: "" });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new LocationService();
